import {Container, Text} from "@bounce/shared/ui";
import CloseIcon from "@mui/icons-material/Close";
import {Dialog, DialogContent, IconButton} from "@mui/material";
import React, {useEffect, useState} from "react";
import {ResetAccountTab} from "./tabs";
import {DevToolsWidget} from "./DevToolsWidget";

const DevToolsPanel = () => {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === "D") {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <>
      {!hidden && <DevToolsWidget onClick={() => setOpen(true)} onClose={() => setHidden(true)} />}

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <Container row sx={{justifyContent: "space-between", p: 2, borderBottom: "1px solid #eee"}}>
          <Text variant="inter600" size={18}>
            Dev Tools
          </Text>
          <IconButton onClick={() => setOpen(false)} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Container>

        <DialogContent>
          <ResetAccountTab onClose={() => setOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DevToolsPanel;
